import Cookies from "js-cookie";


function base64UrlDecode(str) {
  if (!str || typeof str !== "string") {
    return null;
  }

  str = str.replace(/-/g, "+").replace(/_/g, "/");

  while (str.length % 4) {
    str += "=";
  }

  try {
    return atob(str);
  } catch (e) {
    return null; // invalid base64
  }
}

    
function safeParseCookie(cookieName) {
  try {
    const raw = Cookies.get(cookieName);
    if (!raw || raw === "undefined" || raw === "null") return null;

    let decoded = raw;
    try {
      decoded = decodeURIComponent(raw);
    } catch {
      decoded = raw;
    }

    try {
      return JSON.parse(decoded);
    } catch {
      return decoded;
    }
  } catch {
    return null;
  }
}

function safeDecodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const decodedStr = base64UrlDecode(parts[1]);
    if (!decodedStr) return null;
    return JSON.parse(decodedStr);
  } catch {
    return null;
  }
}

// Safely initialize state from cookies
let userValue = safeParseCookie("otp-data");
let userValueDetail = null;
let userValueDetailLogin = null;

const tokenAuth = safeParseCookie("authTokenUser");
if (tokenAuth) {
  userValueDetail = safeDecodeJwtPayload(tokenAuth);
}

const tokenAuthLogin = safeParseCookie("authTokenUserLogin");
if (tokenAuthLogin) {
  userValueDetailLogin = safeDecodeJwtPayload(tokenAuthLogin);
}




const initialState = {
  loading: false,
  user: userValue,
  userDetail:userValueDetail,
  userDetailLogin:userValueDetailLogin,
  otpSent: false,
  isVerified: false,
  email: null,
  error: null,
  planChangeStatus:false
};

function authReducer(state = initialState, action) {
  
  
  
    switch (action.type) {
    case "REGISTER_REQUEST":
    case "VERIFY_OTP_REQUEST":
      return { ...state, loading: true, error: null };

    case "REGISTER_SUCCESS":
      return { ...state, loading: false, otpSent: true, user: action.payload };

    case "REGISTER_FAILURE":
      return { ...state, loading: false, error: action.error };

    case "VERIFY_OTP_SUCCESS":
      return { ...state, loading: false, isVerified: true, userDetail: action.payload };

    case "VERIFY_OTP_FAILURE":
      return { ...state, loading: false, error: action.error };
    case "REGISTER_SUCCESS_LOGIN":
      return { ...state, loading: false, otpSent: true, userDetailLogin: action.payload };
      
    case "LOGOUT_SUCCESS":
      return { ...state, loading: false,  user: action.payload };

    case "PLAN_CHANGE":
      return { ...state, loading: false,  planChangeStatus:action.payload };

    case "LOGOUT_FAILURE":
      return { ...state, loading: false, error: action.error };  

    default:
      return state;
  }
}

export default authReducer;
